import { Spacer } from '#app/components/spacer.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { chromeExtensionLink } from '#app/utils/chrome-extension.ts'

export function ChromeExtension() {
	return (
		<div className="container">
			<Spacer size="lg" />
			<div className="flex flex-col justify-between md:flex-row gap-8">
				<div className="flex-[1] block">
					<h4 className='text-3xl'>Face swap any photo that you find on the internet!</h4>
					<Spacer size="xs" />
					<p className='p-0 m-0'>
						With our chrome extension you can just select any picture on your
						browser, right click it and put your face on it in a matter of
						seconds. What are you waiting for?
					</p>
          <Spacer size="2xs" />
					<a
						className="border-[1px] border-solid px-8 py-3 rounded-xl bg-app-gradient flex justify-center w-fit"
						href={chromeExtensionLink}
						target="_blank"
						rel="noreferrer"
					>
            <Icon size="lg" name="download" className='mr-2'/>
						Get our chrome extension now!
					</a>
				</div>
				<div className="flex-[1] md:ml-8 ">
					<video
						className="rounded-md"
						src="/img/video/chrome-ext.mp4"
						autoPlay
						loop
						muted
						playsInline
					/>
				</div>
			</div>
		</div>
	)
}
